import { patientApi } from "./patientApi";

export const mentalHealthApi = patientApi.injectEndpoints({
  endpoints: (builder) => ({
    getPatientScores: builder.query<{ gad7: number; phq9: number }, void>({
      query: () => ({
        method: "GET",
        url: `/api/patient/mental-health-scores`,
      }),
    }),
  }),
});

export const { useGetPatientScoresQuery } = mentalHealthApi;
